
export default {
  props: {
    icon: {
      type: String,
      default: '',
    },
    program: {
      type: Object,
      required: true,
    },
  },
  data: vm => ({
    formOpened: false,
  }),
};
